import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { engagementService } from '../services/api';

export default function EngagementsPage() {
  const [engagements, setEngagements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEngagements();
  }, []);

  const loadEngagements = async () => {
    try {
      const data = await engagementService.getAll();
      setEngagements(data);
    } catch (error) {
      console.error('Error loading engagements:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      active: 'badge-success',
      paused: 'badge-warning',
      completed: 'badge-info',
      cancelled: 'badge-danger',
    };
    return badges[status] || 'badge-gray';
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Engagements | CR Hood Admin</title>
      </Helmet>

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Engagements</h1>
          <div className="flex gap-2">
            <Link to="/engagements/calendar" className="btn btn-secondary">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Calendar
            </Link>
            <Link to="/engagements/new" className="btn btn-primary">New Engagement</Link>
          </div>
        </div>

        <div className="card p-0 overflow-hidden">
          {engagements.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No engagements yet</p>
              <p className="text-sm text-gray-400 mt-1">Engagements are created from accepted proposals</p>
            </div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Client</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {engagements.map((engagement) => (
                    <tr key={engagement.id}>
                      <td className="font-medium">{engagement.title}</td>
                      <td>{engagement.client?.name || '-'}</td>
                      <td>
                        <span className={`badge ${getStatusBadge(engagement.status)}`}>
                          {engagement.status}
                        </span>
                      </td>
                      <td>{engagement.startDate ? new Date(engagement.startDate).toLocaleDateString() : '-'}</td>
                      <td>{engagement.endDate ? new Date(engagement.endDate).toLocaleDateString() : '-'}</td>
                      <td>
                        <Link
                          to={`/engagements/${engagement.id}`}
                          className="text-accent hover:underline text-sm"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
